import { NotificationsOverlayProps } from './notifications-overlay.types';

export const NotificationsOverlayPresets: Partial<NotificationsOverlayProps> = {
  notifications: [],
};
